import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router';
import { dateToString } from 'services/utils/date';
import { Table, OverlayTrigger, Form } from 'react-bootstrap';
import styled from 'styled-components';
import { firstLetterToUpperCase } from 'services/utils/string';
import { getOrdersSchedules } from './utils';
import FlexRow from 'templates/FlexRowTemplate';

const Wrapper = styled.div`
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
`;
const Tr = styled.tr`
  &:hover {
    background-color: #ececec;
  }
`;
const Th = styled.th`
  background-color: ${({ dayName }) => {
    if (dayName === 'Sobota') return '#e6f8e2';
    if (dayName === 'Niedziela') return '#f7eded';
    return 'inherit';
  }};
`;
const Td = styled.td`
  position: 'relative';
  background-color: ${({ dayName }) => {
    if (dayName === 'Sobota') return '#e6f8e2';
    if (dayName === 'Niedziela') return '#f7eded';
    return 'inherit';
  }};
`;

const TableView = ({ timetables }) => {
  const history = useHistory();
  const [days, setDays] = useState(null);
  const [orders, setOrders] = useState(null);
  const [filteredOrders, setFilteredOrders] = useState(null);
  const [customersList, setCustomersList] = useState(null);
  const [customer, setCustomer] = useState('');

  useEffect(() => {
    if (timetables) {
      const result = getOrdersSchedules(timetables);
      setOrders(result.schedules);
      setDays(result.dates);
      setCustomersList(result.customersList);
    }
  }, [timetables]);

  useEffect(() => {
    if (orders) {
      let newFilteredOrders = [...orders];
      if (customer)
        newFilteredOrders = newFilteredOrders.filter(
          (item) => item.customerId === customer,
        );

      setFilteredOrders(newFilteredOrders);
    }
  }, [orders, customer]);

  return (
    <Wrapper>
      <Filter
        customers={customersList}
        value={customer}
        onChange={(e) => setCustomer(e.target.value)}
        disabled={
          !customersList ||
          !customersList.length ||
          !orders ||
          !orders.length
        }
      />
      <Table bordered>
        <thead>
          <tr>
            <th style={{ width: 100 }}>Zamówienie</th>
            {days &&
              days.map((day) => (
                <Th key={day.date} dayName={day.name}>
                  {dateToString(day.date)} {day.name}
                </Th>
              ))}
          </tr>
        </thead>
        <tbody>
          {filteredOrders &&
            filteredOrders.map((order) => {
              return (
                <Tr key={order.orderId}>
                  <td
                    onClick={() => history.push(`/order/${order.orderId}`)}
                    style={{ fontWeight: 'bold', cursor: 'pointer' }}
                  >
                    {order.orderName}
                  </td>
                  {order.schedule.map((item, index) => {
                    return (
                      <Td
                        key={item.positions.join('.') + index}
                        dayName={item.dayName}
                      >
                        {item.positions.map((pos) => (
                          <span key={pos} className={pos}>
                            {firstLetterToUpperCase(pos)},{' '}
                          </span>
                        ))}
                      </Td>
                    );
                  })}
                </Tr>
              );
            })}
        </tbody>
      </Table>
    </Wrapper>
  );
};

export default TableView;

const InfoCard = ({ order }) => {
  return (
    <Card>
      <InfoItem name="Kolor" value={order.color} />
      <InfoItem name="Matowość" value={order.paintType} />
      <InfoItem name="Elementy" value={order.elements} />
      <InfoItem
        name="PL"
        value={order.surfaceRight ? order.surfaceRight.toFixed(2) : 0}
      />
      <InfoItem
        name="PP"
        value={order.surfaceLeft ? order.surfaceLeft.toFixed(2) : 0}
      />
      {order.milling ? (
        <InfoItem
          name="Wzór frezowania"
          value={order.milling.join(', ')}
        />
      ) : null}
      {order.veneer ? (
        <InfoItem name="Wzór forniru" value={order.veneer} />
      ) : null}
      <InfoItem
        name="Data realizacji"
        value={dateToString(order.finishDate)}
      />
      <InfoItem
        name="Status"
        value={order.status.map((item) => `${item}, `)}
      />
    </Card>
  );
};

const InfoItem = ({ name, value }) => (
  <div>
    <span>{name}</span>
    <strong> {value}</strong>
  </div>
);
const Card = styled.div`
  position: absolute;
  top: -80%;
  left: 50%;
  border: 1px solid lightgray;
  border-radius: 5px;
  background-color: white;
  padding: 5px;
  font-size: 11px;
  width: 200px;
  z-index: 99999;
`;

const Filter = ({ value, disabled, onChange, customers }) => (
  <FlexRow justify="flex-start">
    <Form.Control
      as="select"
      onChange={onChange}
      value={value}
      disabled={disabled}
      style={{ width: 200, marginBottom: 5 }}
    >
      <option value="" />
      {customers &&
        customers
          .sort((a, b) =>
            `${a.customerName}`.localeCompare(b.customerName),
          )
          .map((item) => (
            <option
              value={item.customerId}
              key={item.customerId}
              status={item}
            >
              {item.customerName}
            </option>
          ))}
    </Form.Control>
  </FlexRow>
);
